// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

export type BonusDto = {
    type: BonusType;
    xp: number;
};

export enum BonusType {
    COLLABORATION = 'Collaboration',
    IN_TIME_STREAK = 'InTimeStreak',
    OVERDUE = 'Overdue'
}

export type CategoryDto = {
    id: string;
    name: string;
};

export type CategoryLevelStatusDto = {
    categoryId?: string;
    categoryName?: null | string;
    status?: null | LevelStatusDto;
};

export type CategoryLevelUpdateDto = {
    categoryId?: string;
    categoryName?: null | string;
    levelUpdate?: null | LevelUpdateDto;
};

export type CategoryRankDto = {
    categoryName: string;
    categoryId: string;
    level: number;
    levelName: string;
};

export type ChangelogDto = {
    id: string;
    version: string;
    content: string;
    createdAt: Date;
};

export type ChangelogReadDto = {
    changelogIds: Array<string>;
};

export type ChooseWinnerPrizeDto = {
    chosenPrizeSuggestionId: string;
};

export type ChoreDto = {
    id: string;
    name: string;
    description?: null | string;
    estimatedMinutes: number;
    difficultyLevel: DifficultyLevel;
    categoryId: string;
    autoSchedule: boolean;
    recurrenceInterval?: null | RecurrenceIntervalType;
    isOneTimeTask: boolean;
    baseXp: number;
    isDeleted?: boolean;
};

export type ChoreInstanceDto = {
    id: string;
    choreId: string;
    choreName: string;
    dueAt?: null | Date;
    status: ChoreInstanceStatus;
    assignedUserId?: null | string;
    assignedUserName?: null | string;
    performedChoreId?: null | string;
    isOverdue: boolean;
};

export enum ChoreInstanceStatus {
    PENDING = 'Pending',
    IN_PROGRESS = 'InProgress',
    COMPLETED = 'Completed',
    SKIPPED = 'Skipped'
}

export type ChoreTileDto = {
    choreId: string;
    name: string;
    description?: null | string;
    estimatedMinutes: number;
    difficultyLevel: DifficultyLevel;
    categoryName: string;
    categoryId: string;
    autoSchedule: boolean;
    recurrenceInterval?: null | RecurrenceIntervalType;
    isOneTimeTask: boolean;
    baseXp: number;
    choreInstanceId?: null | string;
    dueAt?: null | Date;
    status?: null | ChoreInstanceStatus;
    assignedUserName?: null | string;
    isAdHocTask?: boolean;
    lastPerformedAt?: null | Date;
    appliedBonuses?: Array<BonusDto>;
    performedCount: number;
    bonusXp?: number;
};

export type CreateAndPerformOneTimeChoreDto = {
    name: string;
    description?: null | string;
    estimatedMinutes: number;
    categoryId: string;
    difficultyLevel: DifficultyLevel;
};

export type CreateCategoryDto = {
    name: string;
};

export type CreateChoreDto = {
    name: string;
    description?: null | string;
    estimatedMinutes: number;
    categoryId: string;
    difficultyLevel: DifficultyLevel;
    recurrenceInterval?: null | RecurrenceIntervalType;
    autoSchedule?: boolean;
    isOneTimeTask?: boolean;
};

export type CreateChoreInstanceDto = {
    choreId: string;
    dueAt: null | Date;
    assignedUserId?: null | string;
};

export type CreateInitialChoreDto = {
    name: string;
    description?: null | string;
    estimatedMinutes: number;
    categoryName: string;
    difficultyLevel: DifficultyLevel;
    recurrenceInterval?: null | RecurrenceIntervalType;
    autoSchedule?: boolean;
};

export type CreateOneTimeChoreInstanceDto = {
    name: string;
    description?: null | string;
    estimatedMinutes: number;
    categoryId: string;
    difficultyLevel: DifficultyLevel;
    dueAt: null | Date;
    assignedUserId?: null | string;
};

export type CreatePerformedChoreDto = {
    choreId?: null | string;
    choreInstanceId?: null | string;
};

export type CreatePerformedChoresDto = {
    performedChores: Array<CreatePerformedChoreDto>;
    performedOneTimeChores: Array<CreateAndPerformOneTimeChoreDto>;
    performedAt?: null | Date;
    participantUserIds: Array<string>;
};

export type CreatePerformedChoresResponseDto = {
    performedChores: Array<PerformedChoreDto>;
    userXpUpdates: Array<UserXpUpdateDto>;
};

export type CreatePrizeSuggestionDto = {
    description: string;
};

export type CreateUserDto = {
    username: string;
    invitationToken?: null | string;
};

export enum DevicePlatform {
    ANDROID = 'Android',
    IOS = 'Ios'
}

export enum DifficultyLevel {
    EASY = 'Easy',
    MEDIUM = 'Medium',
    HARD = 'Hard',
    VERY_HARD = 'VeryHard'
}

export type HouseholdDto = {
    id: string;
    needsOnboarding?: boolean;
};

export type JoinHouseholdDto = {
    token: string;
};

export type LevelStatusDto = {
    level?: number;
    currentXp?: number;
    xpForCurrentLevel?: number;
    xpForNextLevel?: number;
};

export type LevelUpdateDto = {
    oldLevel?: number;
    newLevel?: number;
    oldXp?: number;
    newXp?: number;
    xpForCurrentLevel?: number;
    xpForNextLevel?: number;
};

export type MonthlyPrizeSelectionDto = {
    id: string;
    userId?: string;
    username?: string;
    month?: number;
    year?: number;
    prizeSuggestionId?: string;
    prizeDescription?: string;
};

export type MonthlyResultDto = {
    id?: string;
    month?: number;
    year?: number;
    prizeSuggestions?: Array<PrizeSuggestionDto>;
    winnerGuid?: string;
    winnerUsername?: string;
    runnerUpGuid?: null | string;
    runnerUpUsername?: null | string;
    chosenByRunnerUpPrizeSuggestionId?: null | string;
    winnerConfirmedPrizeDescription?: null | string;
    monthlyXpResults?: Array<MonthlyXpResultDto>;
    isRunnerUp?: boolean;
    isWinner?: boolean;
    actionRequired?: boolean;
    status?: MonthlyResultStatus;
};

export enum MonthlyResultStatus {
    UNKNOWN = 'Unknown',
    WAITING_FOR_WINNER_SUGGESTIONS = 'WaitingForWinnerSuggestions',
    WAITING_FOR_RUNNER_UP_CHOICE = 'WaitingForRunnerUpChoice',
    NO_RUNNER_UP = 'NoRunnerUp',
    REDEEMABLE = 'Redeemable',
    REDEEMED = 'Redeemed'
}

export type MonthlyXpResultDto = {
    userGuid?: string;
    username?: string;
    xp?: number;
};

export type NotificationPreferencesDto = {
    levelUps: boolean;
    leadChanges: boolean;
    contest: boolean;
    monthEndReminders: boolean;
    dailyReminder: boolean;
    dailyReminderTime: string;
};

export type OnboardingHouseholdDto = {
    chores?: Array<CreateInitialChoreDto>;
    uniqueCategories?: null | Array<string>;
    uniqueDifficultyLevels?: null | Array<DifficultyLevel>;
    prizeSuggestions?: Array<string>;
};

export type PerformedChoreDto = {
    id: string;
    choreInstanceId: string;
    choreId: string;
    choreName: string;
    categoryId: string;
    categoryName: string;
    participants?: Array<PerformedChoreParticipantDto>;
    performedAt: Date;
};

export type PerformedChoreParticipantDto = {
    userId?: string;
    username: string;
    baseXpAwarded?: number;
    bonusXpAwarded?: number;
    totalXpAwarded?: number;
};

export type PrizeSuggestionDto = {
    id: string;
    description?: string;
};

export enum RecurrenceIntervalType {
    DAILY = 'Daily',
    TWICE_WEEKLY = 'TwiceWeekly',
    WEEKLY = 'Weekly',
    BI_WEEKLY = 'BiWeekly',
    MONTHLY = 'Monthly',
    BI_MONTHLY = 'BiMonthly',
    YEARLY = 'Yearly'
}

export type RegisterDeviceDto = {
    installationId: string;
    platform: DevicePlatform;
    locale: string;
    timeZone: null | string;
};

export type SetFinalPrizeDto = {
    existingPrizeSuggestionId?: null | string;
    newPrizeSuggestionDescription?: null | string;
};

export type SetMonthlySelectionsDto = {
    prizeSuggestionIds: Array<string>;
};

export type UpdateChoreDto = {
    id: string;
    name: string;
    description?: null | string;
    estimatedMinutes: number;
    difficultyLevel: DifficultyLevel;
    categoryId: string;
    autoSchedule?: boolean;
    recurrenceInterval?: null | RecurrenceIntervalType;
    isOneTimeTask?: boolean;
};

export type UpdateChoreInstanceDto = {
    id: string;
    dueAt?: null | Date;
    assignedUserId?: null | string;
    status?: null | ChoreInstanceStatus;
};

export type UpdatePrizeSuggestionDto = {
    id: string;
    description: string;
};

export type UpdateUserDto = {
    username: string;
    id: string;
};

export type UserDto = {
    username: string;
    id: string;
};

export type UserGamificationProfileDto = {
    userId?: string;
    userName: string;
    mainLevel?: null | LevelStatusDto;
    categoryLevels?: null | Array<CategoryLevelStatusDto>;
};

export type UserXpUpdateDto = {
    userId: string;
    mainLevelUpdate: LevelUpdateDto;
    categoryLevelUpdates: Array<CategoryLevelUpdateDto>;
};

export type GetApiV1MonthlyPrizeSelectionsData = {
    body?: never;
    path?: never;
    query?: {
        year?: number;
        month?: number;
    };
    url: '/api/v1/MonthlyPrizeSelections';
};

export type GetApiV1MonthlyPrizeSelectionsResponses = {
    /**
     * OK
     */
    200: Array<MonthlyPrizeSelectionDto>;
};

export type GetApiV1MonthlyPrizeSelectionsResponse = GetApiV1MonthlyPrizeSelectionsResponses[keyof GetApiV1MonthlyPrizeSelectionsResponses];

export type PostApiV1MonthlyPrizeSelectionsData = {
    body: SetMonthlySelectionsDto;
    path?: never;
    query?: never;
    url: '/api/v1/MonthlyPrizeSelections';
};

export type PostApiV1MonthlyPrizeSelectionsErrors = {
    /**
     * Bad Request
     */
    400: string;
};

export type PostApiV1MonthlyPrizeSelectionsError = PostApiV1MonthlyPrizeSelectionsErrors[keyof PostApiV1MonthlyPrizeSelectionsErrors];

export type PostApiV1MonthlyPrizeSelectionsResponses = {
    /**
     * Created
     */
    201: Array<PrizeSuggestionDto>;
};

export type PostApiV1MonthlyPrizeSelectionsResponse = PostApiV1MonthlyPrizeSelectionsResponses[keyof PostApiV1MonthlyPrizeSelectionsResponses];

export type GetApiV1MonthlyPrizeSelectionsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/MonthlyPrizeSelections/{id}';
};

export type GetApiV1MonthlyPrizeSelectionsByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1MonthlyPrizeSelectionsByIdResponses = {
    /**
     * OK
     */
    200: MonthlyPrizeSelectionDto;
};

export type GetApiV1MonthlyPrizeSelectionsByIdResponse = GetApiV1MonthlyPrizeSelectionsByIdResponses[keyof GetApiV1MonthlyPrizeSelectionsByIdResponses];

export type GetApiV1MonthlyResultsData = {
    body?: never;
    path?: never;
    query?: {
        year?: number;
        month?: number;
    };
    url: '/api/v1/MonthlyResults';
};

export type GetApiV1MonthlyResultsResponses = {
    /**
     * OK
     */
    200: Array<MonthlyResultDto>;
};

export type GetApiV1MonthlyResultsResponse = GetApiV1MonthlyResultsResponses[keyof GetApiV1MonthlyResultsResponses];

export type GetApiV1MonthlyResultsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/MonthlyResults/{id}';
};

export type GetApiV1MonthlyResultsByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1MonthlyResultsByIdResponses = {
    /**
     * OK
     */
    200: MonthlyResultDto;
};

export type GetApiV1MonthlyResultsByIdResponse = GetApiV1MonthlyResultsByIdResponses[keyof GetApiV1MonthlyResultsByIdResponses];

export type PutApiV1MonthlyResultsByIdPatchSuggestionsData = {
    body: SetMonthlySelectionsDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/MonthlyResults/{id}/patch-suggestions';
};

export type PutApiV1MonthlyResultsByIdPatchSuggestionsErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type PutApiV1MonthlyResultsByIdPatchSuggestionsError = PutApiV1MonthlyResultsByIdPatchSuggestionsErrors[keyof PutApiV1MonthlyResultsByIdPatchSuggestionsErrors];

export type PutApiV1MonthlyResultsByIdPatchSuggestionsResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1MonthlyResultsByIdPatchSuggestionsResponse = PutApiV1MonthlyResultsByIdPatchSuggestionsResponses[keyof PutApiV1MonthlyResultsByIdPatchSuggestionsResponses];

export type PutApiV1MonthlyResultsByIdChoosePrizeData = {
    body: ChooseWinnerPrizeDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/MonthlyResults/{id}/choose-prize';
};

export type PutApiV1MonthlyResultsByIdChoosePrizeErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type PutApiV1MonthlyResultsByIdChoosePrizeError = PutApiV1MonthlyResultsByIdChoosePrizeErrors[keyof PutApiV1MonthlyResultsByIdChoosePrizeErrors];

export type PutApiV1MonthlyResultsByIdChoosePrizeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1MonthlyResultsByIdChoosePrizeResponse = PutApiV1MonthlyResultsByIdChoosePrizeResponses[keyof PutApiV1MonthlyResultsByIdChoosePrizeResponses];

export type PutApiV1MonthlyResultsByIdSetFinalPrizeData = {
    body: SetFinalPrizeDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/MonthlyResults/{id}/set-final-prize';
};

export type PutApiV1MonthlyResultsByIdSetFinalPrizeErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type PutApiV1MonthlyResultsByIdSetFinalPrizeError = PutApiV1MonthlyResultsByIdSetFinalPrizeErrors[keyof PutApiV1MonthlyResultsByIdSetFinalPrizeErrors];

export type PutApiV1MonthlyResultsByIdSetFinalPrizeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1MonthlyResultsByIdSetFinalPrizeResponse = PutApiV1MonthlyResultsByIdSetFinalPrizeResponses[keyof PutApiV1MonthlyResultsByIdSetFinalPrizeResponses];

export type GetApiV1PrizeSuggestionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/PrizeSuggestions';
};

export type GetApiV1PrizeSuggestionsResponses = {
    /**
     * OK
     */
    200: Array<PrizeSuggestionDto>;
};

export type GetApiV1PrizeSuggestionsResponse = GetApiV1PrizeSuggestionsResponses[keyof GetApiV1PrizeSuggestionsResponses];

export type PostApiV1PrizeSuggestionsData = {
    body: CreatePrizeSuggestionDto;
    path?: never;
    query?: never;
    url: '/api/v1/PrizeSuggestions';
};

export type PostApiV1PrizeSuggestionsResponses = {
    /**
     * Created
     */
    201: PrizeSuggestionDto;
};

export type PostApiV1PrizeSuggestionsResponse = PostApiV1PrizeSuggestionsResponses[keyof PostApiV1PrizeSuggestionsResponses];

export type DeleteApiV1PrizeSuggestionsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/PrizeSuggestions/{id}';
};

export type DeleteApiV1PrizeSuggestionsByIdErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteApiV1PrizeSuggestionsByIdError = DeleteApiV1PrizeSuggestionsByIdErrors[keyof DeleteApiV1PrizeSuggestionsByIdErrors];

export type DeleteApiV1PrizeSuggestionsByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PrizeSuggestionsByIdResponse = DeleteApiV1PrizeSuggestionsByIdResponses[keyof DeleteApiV1PrizeSuggestionsByIdResponses];

export type GetApiV1PrizeSuggestionsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/PrizeSuggestions/{id}';
};

export type GetApiV1PrizeSuggestionsByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1PrizeSuggestionsByIdResponses = {
    /**
     * OK
     */
    200: PrizeSuggestionDto;
};

export type GetApiV1PrizeSuggestionsByIdResponse = GetApiV1PrizeSuggestionsByIdResponses[keyof GetApiV1PrizeSuggestionsByIdResponses];

export type PutApiV1PrizeSuggestionsByIdData = {
    body: UpdatePrizeSuggestionDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/PrizeSuggestions/{id}';
};

export type PutApiV1PrizeSuggestionsByIdErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type PutApiV1PrizeSuggestionsByIdError = PutApiV1PrizeSuggestionsByIdErrors[keyof PutApiV1PrizeSuggestionsByIdErrors];

export type PutApiV1PrizeSuggestionsByIdResponses = {
    /**
     * OK
     */
    200: PrizeSuggestionDto;
};

export type PutApiV1PrizeSuggestionsByIdResponse = PutApiV1PrizeSuggestionsByIdResponses[keyof PutApiV1PrizeSuggestionsByIdResponses];

export type PutApiV1DevicesData = {
    body: RegisterDeviceDto;
    path?: never;
    query?: never;
    url: '/api/v1/Devices';
};

export type PutApiV1DevicesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PutApiV1DevicesResponse = PutApiV1DevicesResponses[keyof PutApiV1DevicesResponses];

export type DeleteApiV1DevicesByInstallationIdData = {
    body?: never;
    path: {
        installationId: string;
    };
    query?: never;
    url: '/api/v1/Devices/{installationId}';
};

export type DeleteApiV1DevicesByInstallationIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1DevicesByInstallationIdResponse = DeleteApiV1DevicesByInstallationIdResponses[keyof DeleteApiV1DevicesByInstallationIdResponses];

export type PostApiV1DevicesTestData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Devices/test';
};

export type PostApiV1DevicesTestResponses = {
    /**
     * Accepted
     */
    202: unknown;
};

export type GetApiV1NotificationPreferencesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/NotificationPreferences';
};

export type GetApiV1NotificationPreferencesResponses = {
    /**
     * OK
     */
    200: NotificationPreferencesDto;
};

export type GetApiV1NotificationPreferencesResponse = GetApiV1NotificationPreferencesResponses[keyof GetApiV1NotificationPreferencesResponses];

export type PutApiV1NotificationPreferencesData = {
    body: NotificationPreferencesDto;
    path?: never;
    query?: never;
    url: '/api/v1/NotificationPreferences';
};

export type PutApiV1NotificationPreferencesResponses = {
    /**
     * OK
     */
    200: NotificationPreferencesDto;
};

export type PutApiV1NotificationPreferencesResponse = PutApiV1NotificationPreferencesResponses[keyof PutApiV1NotificationPreferencesResponses];

export type GetApiV1ChangelogsData = {
    body?: never;
    path?: never;
    query?: {
        'only-new'?: boolean;
    };
    url: '/api/v1/Changelogs';
};

export type GetApiV1ChangelogsResponses = {
    /**
     * OK
     */
    200: Array<ChangelogDto>;
};

export type GetApiV1ChangelogsResponse = GetApiV1ChangelogsResponses[keyof GetApiV1ChangelogsResponses];

export type PostApiV1ChangelogsReadData = {
    body: ChangelogReadDto;
    path?: never;
    query?: never;
    url: '/api/v1/Changelogs/read';
};

export type PostApiV1ChangelogsReadResponses = {
    /**
     * No Content
     */
    204: void;
};

export type PostApiV1ChangelogsReadResponse = PostApiV1ChangelogsReadResponses[keyof PostApiV1ChangelogsReadResponses];

export type GetApiV1HouseholdsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Households';
};

export type GetApiV1HouseholdsResponses = {
    /**
     * OK
     */
    200: Array<HouseholdDto>;
};

export type GetApiV1HouseholdsResponse = GetApiV1HouseholdsResponses[keyof GetApiV1HouseholdsResponses];

export type GetApiV1HouseholdsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Households/{id}';
};

export type GetApiV1HouseholdsByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1HouseholdsByIdResponses = {
    /**
     * OK
     */
    200: HouseholdDto;
};

export type GetApiV1HouseholdsByIdResponse = GetApiV1HouseholdsByIdResponses[keyof GetApiV1HouseholdsByIdResponses];

export type GetApiV1HouseholdsInvitationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Households/invitation';
};

export type GetApiV1HouseholdsInvitationResponses = {
    /**
     * OK
     */
    200: string;
};

export type GetApiV1HouseholdsInvitationResponse = GetApiV1HouseholdsInvitationResponses[keyof GetApiV1HouseholdsInvitationResponses];

export type PostApiV1HouseholdsOnboardingData = {
    body: OnboardingHouseholdDto;
    path?: never;
    query?: never;
    url: '/api/v1/Households/onboarding';
};

export type PostApiV1HouseholdsOnboardingErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type PostApiV1HouseholdsOnboardingError = PostApiV1HouseholdsOnboardingErrors[keyof PostApiV1HouseholdsOnboardingErrors];

export type PostApiV1HouseholdsOnboardingResponses = {
    /**
     * OK
     */
    200: HouseholdDto;
};

export type PostApiV1HouseholdsOnboardingResponse = PostApiV1HouseholdsOnboardingResponses[keyof PostApiV1HouseholdsOnboardingResponses];

export type PostApiV1HouseholdsJoinData = {
    body: JoinHouseholdDto;
    path?: never;
    query?: never;
    url: '/api/v1/Households/join';
};

export type PostApiV1HouseholdsJoinErrors = {
    /**
     * Bad Request
     */
    400: string;
};

export type PostApiV1HouseholdsJoinError = PostApiV1HouseholdsJoinErrors[keyof PostApiV1HouseholdsJoinErrors];

export type PostApiV1HouseholdsJoinResponses = {
    /**
     * OK
     */
    200: HouseholdDto;
};

export type PostApiV1HouseholdsJoinResponse = PostApiV1HouseholdsJoinResponses[keyof PostApiV1HouseholdsJoinResponses];

export type GetApiV1LevelsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Levels';
};

export type GetApiV1LevelsResponses = {
    /**
     * OK
     */
    200: Array<UserGamificationProfileDto>;
};

export type GetApiV1LevelsResponse = GetApiV1LevelsResponses[keyof GetApiV1LevelsResponses];

export type GetApiV1LevelsByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Levels/{id}';
};

export type GetApiV1LevelsByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1LevelsByIdResponses = {
    /**
     * OK
     */
    200: UserGamificationProfileDto;
};

export type GetApiV1LevelsByIdResponse = GetApiV1LevelsByIdResponses[keyof GetApiV1LevelsByIdResponses];

export type GetApiV1RanksCategoriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Ranks/categories';
};

export type GetApiV1RanksCategoriesResponses = {
    /**
     * OK
     */
    200: Array<CategoryRankDto>;
};

export type GetApiV1RanksCategoriesResponse = GetApiV1RanksCategoriesResponses[keyof GetApiV1RanksCategoriesResponses];

export type GetApiV1RanksCategoriesByCategoryIdData = {
    body?: never;
    path: {
        categoryId: string;
    };
    query?: never;
    url: '/api/v1/Ranks/categories/{categoryId}';
};

export type GetApiV1RanksCategoriesByCategoryIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1RanksCategoriesByCategoryIdResponses = {
    /**
     * OK
     */
    200: Array<CategoryRankDto>;
};

export type GetApiV1RanksCategoriesByCategoryIdResponse = GetApiV1RanksCategoriesByCategoryIdResponses[keyof GetApiV1RanksCategoriesByCategoryIdResponses];

export type GetApiV1UsersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Users';
};

export type GetApiV1UsersResponses = {
    /**
     * OK
     */
    200: Array<UserDto>;
};

export type GetApiV1UsersResponse = GetApiV1UsersResponses[keyof GetApiV1UsersResponses];

export type PostApiV1UsersData = {
    body: CreateUserDto;
    path?: never;
    query?: never;
    url: '/api/v1/Users';
};

export type PostApiV1UsersErrors = {
    /**
     * Bad Request
     */
    400: string;
};

export type PostApiV1UsersError = PostApiV1UsersErrors[keyof PostApiV1UsersErrors];

export type PostApiV1UsersResponses = {
    /**
     * Created
     */
    201: UserDto;
};

export type PostApiV1UsersResponse = PostApiV1UsersResponses[keyof PostApiV1UsersResponses];

export type GetApiV1UsersByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Users/{id}';
};

export type GetApiV1UsersByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1UsersByIdResponses = {
    /**
     * OK
     */
    200: UserDto;
};

export type GetApiV1UsersByIdResponse = GetApiV1UsersByIdResponses[keyof GetApiV1UsersByIdResponses];

export type PutApiV1UsersByIdData = {
    body: UpdateUserDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Users/{id}';
};

export type PutApiV1UsersByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type PutApiV1UsersByIdResponses = {
    /**
     * OK
     */
    200: UserDto;
};

export type PutApiV1UsersByIdResponse = PutApiV1UsersByIdResponses[keyof PutApiV1UsersByIdResponses];

export type GetApiV1CategoriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Categories';
};

export type GetApiV1CategoriesResponses = {
    /**
     * OK
     */
    200: Array<CategoryDto>;
};

export type GetApiV1CategoriesResponse = GetApiV1CategoriesResponses[keyof GetApiV1CategoriesResponses];

export type PostApiV1CategoriesData = {
    body: CreateCategoryDto;
    path?: never;
    query?: never;
    url: '/api/v1/Categories';
};

export type PostApiV1CategoriesErrors = {
    /**
     * Bad Request
     */
    400: string;
};

export type PostApiV1CategoriesError = PostApiV1CategoriesErrors[keyof PostApiV1CategoriesErrors];

export type PostApiV1CategoriesResponses = {
    /**
     * Created
     */
    201: CategoryDto;
};

export type PostApiV1CategoriesResponse = PostApiV1CategoriesResponses[keyof PostApiV1CategoriesResponses];

export type DeleteApiV1CategoriesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Categories/{id}';
};

export type DeleteApiV1CategoriesByIdErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteApiV1CategoriesByIdError = DeleteApiV1CategoriesByIdErrors[keyof DeleteApiV1CategoriesByIdErrors];

export type DeleteApiV1CategoriesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1CategoriesByIdResponse = DeleteApiV1CategoriesByIdResponses[keyof DeleteApiV1CategoriesByIdResponses];

export type GetApiV1CategoriesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Categories/{id}';
};

export type GetApiV1CategoriesByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1CategoriesByIdResponses = {
    /**
     * OK
     */
    200: CategoryDto;
};

export type GetApiV1CategoriesByIdResponse = GetApiV1CategoriesByIdResponses[keyof GetApiV1CategoriesByIdResponses];

export type GetApiV1ChoreBoardData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/ChoreBoard';
};

export type GetApiV1ChoreBoardResponses = {
    /**
     * OK
     */
    200: Array<ChoreTileDto>;
};

export type GetApiV1ChoreBoardResponse = GetApiV1ChoreBoardResponses[keyof GetApiV1ChoreBoardResponses];

export type GetApiV1ChoreInstancesData = {
    body?: never;
    path?: never;
    query?: {
        choreId?: string;
        skip?: number;
        take?: number;
    };
    url: '/api/v1/ChoreInstances';
};

export type GetApiV1ChoreInstancesResponses = {
    /**
     * OK
     */
    200: Array<ChoreInstanceDto>;
};

export type GetApiV1ChoreInstancesResponse = GetApiV1ChoreInstancesResponses[keyof GetApiV1ChoreInstancesResponses];

export type PostApiV1ChoreInstancesData = {
    body: CreateChoreInstanceDto;
    path?: never;
    query?: never;
    url: '/api/v1/ChoreInstances';
};

export type PostApiV1ChoreInstancesErrors = {
    /**
     * Bad Request
     */
    400: string;
};

export type PostApiV1ChoreInstancesError = PostApiV1ChoreInstancesErrors[keyof PostApiV1ChoreInstancesErrors];

export type PostApiV1ChoreInstancesResponses = {
    /**
     * Created
     */
    201: ChoreInstanceDto;
};

export type PostApiV1ChoreInstancesResponse = PostApiV1ChoreInstancesResponses[keyof PostApiV1ChoreInstancesResponses];

export type DeleteApiV1ChoreInstancesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/ChoreInstances/{id}';
};

export type DeleteApiV1ChoreInstancesByIdErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteApiV1ChoreInstancesByIdError = DeleteApiV1ChoreInstancesByIdErrors[keyof DeleteApiV1ChoreInstancesByIdErrors];

export type DeleteApiV1ChoreInstancesByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ChoreInstancesByIdResponse = DeleteApiV1ChoreInstancesByIdResponses[keyof DeleteApiV1ChoreInstancesByIdResponses];

export type GetApiV1ChoreInstancesByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/ChoreInstances/{id}';
};

export type GetApiV1ChoreInstancesByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1ChoreInstancesByIdResponses = {
    /**
     * OK
     */
    200: ChoreInstanceDto;
};

export type GetApiV1ChoreInstancesByIdResponse = GetApiV1ChoreInstancesByIdResponses[keyof GetApiV1ChoreInstancesByIdResponses];

export type PutApiV1ChoreInstancesByIdData = {
    body: UpdateChoreInstanceDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/ChoreInstances/{id}';
};

export type PutApiV1ChoreInstancesByIdErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type PutApiV1ChoreInstancesByIdError = PutApiV1ChoreInstancesByIdErrors[keyof PutApiV1ChoreInstancesByIdErrors];

export type PutApiV1ChoreInstancesByIdResponses = {
    /**
     * OK
     */
    200: ChoreInstanceDto;
};

export type PutApiV1ChoreInstancesByIdResponse = PutApiV1ChoreInstancesByIdResponses[keyof PutApiV1ChoreInstancesByIdResponses];

export type PostApiV1ChoreInstancesOneTimeData = {
    body: CreateOneTimeChoreInstanceDto;
    path?: never;
    query?: never;
    url: '/api/v1/ChoreInstances/one-time';
};

export type PostApiV1ChoreInstancesOneTimeErrors = {
    /**
     * Bad Request
     */
    400: string;
};

export type PostApiV1ChoreInstancesOneTimeError = PostApiV1ChoreInstancesOneTimeErrors[keyof PostApiV1ChoreInstancesOneTimeErrors];

export type PostApiV1ChoreInstancesOneTimeResponses = {
    /**
     * Created
     */
    201: ChoreInstanceDto;
};

export type PostApiV1ChoreInstancesOneTimeResponse = PostApiV1ChoreInstancesOneTimeResponses[keyof PostApiV1ChoreInstancesOneTimeResponses];

export type GetApiV1ChoresData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/Chores';
};

export type GetApiV1ChoresResponses = {
    /**
     * OK
     */
    200: Array<ChoreDto>;
};

export type GetApiV1ChoresResponse = GetApiV1ChoresResponses[keyof GetApiV1ChoresResponses];

export type PostApiV1ChoresData = {
    body: CreateChoreDto;
    path?: never;
    query?: never;
    url: '/api/v1/Chores';
};

export type PostApiV1ChoresErrors = {
    /**
     * Bad Request
     */
    400: string;
};

export type PostApiV1ChoresError = PostApiV1ChoresErrors[keyof PostApiV1ChoresErrors];

export type PostApiV1ChoresResponses = {
    /**
     * Created
     */
    201: ChoreDto;
};

export type PostApiV1ChoresResponse = PostApiV1ChoresResponses[keyof PostApiV1ChoresResponses];

export type DeleteApiV1ChoresByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Chores/{id}';
};

export type DeleteApiV1ChoresByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteApiV1ChoresByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1ChoresByIdResponse = DeleteApiV1ChoresByIdResponses[keyof DeleteApiV1ChoresByIdResponses];

export type GetApiV1ChoresByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Chores/{id}';
};

export type GetApiV1ChoresByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1ChoresByIdResponses = {
    /**
     * OK
     */
    200: ChoreDto;
};

export type GetApiV1ChoresByIdResponse = GetApiV1ChoresByIdResponses[keyof GetApiV1ChoresByIdResponses];

export type PutApiV1ChoresByIdData = {
    body: UpdateChoreDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/Chores/{id}';
};

export type PutApiV1ChoresByIdErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: unknown;
};

export type PutApiV1ChoresByIdError = PutApiV1ChoresByIdErrors[keyof PutApiV1ChoresByIdErrors];

export type PutApiV1ChoresByIdResponses = {
    /**
     * OK
     */
    200: ChoreDto;
};

export type PutApiV1ChoresByIdResponse = PutApiV1ChoresByIdResponses[keyof PutApiV1ChoresByIdResponses];

export type GetApiV1PerformedChoresData = {
    body?: never;
    path?: never;
    query?: {
        fromDate?: Date;
        toDate?: Date;
        skip?: number;
        take?: number;
    };
    url: '/api/v1/PerformedChores';
};

export type GetApiV1PerformedChoresResponses = {
    /**
     * OK
     */
    200: Array<PerformedChoreDto>;
};

export type GetApiV1PerformedChoresResponse = GetApiV1PerformedChoresResponses[keyof GetApiV1PerformedChoresResponses];

export type PostApiV1PerformedChoresData = {
    body: CreatePerformedChoresDto;
    path?: never;
    query?: never;
    url: '/api/v1/PerformedChores';
};

export type PostApiV1PerformedChoresErrors = {
    /**
     * Bad Request
     */
    400: string;
    /**
     * Not Found
     */
    404: string;
};

export type PostApiV1PerformedChoresError = PostApiV1PerformedChoresErrors[keyof PostApiV1PerformedChoresErrors];

export type PostApiV1PerformedChoresResponses = {
    /**
     * OK
     */
    200: CreatePerformedChoresResponseDto;
};

export type PostApiV1PerformedChoresResponse = PostApiV1PerformedChoresResponses[keyof PostApiV1PerformedChoresResponses];

export type DeleteApiV1PerformedChoresByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/PerformedChores/{id}';
};

export type DeleteApiV1PerformedChoresByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type DeleteApiV1PerformedChoresByIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiV1PerformedChoresByIdResponse = DeleteApiV1PerformedChoresByIdResponses[keyof DeleteApiV1PerformedChoresByIdResponses];

export type GetApiV1PerformedChoresByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/PerformedChores/{id}';
};

export type GetApiV1PerformedChoresByIdErrors = {
    /**
     * Not Found
     */
    404: unknown;
};

export type GetApiV1PerformedChoresByIdResponses = {
    /**
     * OK
     */
    200: PerformedChoreDto;
};

export type GetApiV1PerformedChoresByIdResponse = GetApiV1PerformedChoresByIdResponses[keyof GetApiV1PerformedChoresByIdResponses];
